/**
 * @architecture-header 1
 * @layer app
 * @domain parallel-development
 * @responsibility Reserve Agent A's top-level route contribution seam for lane-owned entry pages.
 * @state-owner Agent A feature modules
 * @allowed-imports React Router types; Agent A module public APIs
 * @forbidden Agent B modules; workspace shell internals; direct API clients
 * @public-api agentARoutes consumed by the shared router
 * @side-effects none until an Agent A card contributes a route
 * @tests app router tests and Agent A module Playwright flows
 */

import type { RouteObject } from 'react-router-dom';
import { OrganizationInvitationAcceptanceEntry } from '../../../modules/organization-invitation-acceptance';
import { WorkspaceShell } from '../../../routes/WorkspaceShell';

export const agentARoutes: RouteObject[] = [
  {
    path: '/organization-invitations/:token',
    element: <OrganizationInvitationAcceptanceEntry />,
  },
  { path: '/student/settings', element: <WorkspaceShell desiredRole="student" /> },
  { path: '/student/settings/:tab', element: <WorkspaceShell desiredRole="student" /> },
];
